import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Modal,
  Box,
} from "@mui/material";
import LoginModalContent from "./LoginModalContent";
import { useAuth } from "../context/auth";
import { db } from "../api/firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

const CustomAppBar = styled(AppBar)({
  backgroundColor: "white",
});

const CustomButton = styled(Button)({
  marginLeft: "auto",
  background: "#ba68c8",
  borderRadius: "20px",
  color: "white",
  fontWeight: "bold",
  "&:hover": {
    background: "#ab47bc",
  },
});

const SignUpButton = styled(Button)({
  marginLeft: "8px",
  background: "#d0d0d0",
  borderRadius: "20px",
  color: "black",
  fontWeight: "bold",
  "&:hover": {
    background: "#bcbcbc",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const PublicAppBar = () => {
  const [open, setOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { user } = useAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackClose = () => setSnackOpen(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (user) {
        setLoading(true);
        const userRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        } else {
          const newUserInfo = {
            uid: user.uid,
            name: user.displayName,
            email: user.email,
            avatar: user.photoURL,
            avatarPath: "",
            createdAt: serverTimestamp(),
            isOnline: true,
            isLogin: true,
            isStop: false,
          };
          await setDoc(userRef, newUserInfo);
          setUserInfo(newUserInfo);
        }
        setSnackOpen(true);
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, [user]);

  if (loading) return <div style={{ padding: "20px" }}>Loading...</div>;

  return (
    <>
      <CustomAppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, color: "black" }}>
            MasterMind
          </Typography>
          <CustomButton color="inherit" onClick={handleOpen}>
            ログイン
          </CustomButton>
          <SignUpButton color="inherit" onClick={handleOpen}>
            新規登録
          </SignUpButton>
        </Toolbar>
      </CustomAppBar>


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <LoginModalContent onClose={handleClose} open={open} />
        </Box>
      </Modal>
    </>
  );
};

export default PublicAppBar;
